import type { FC } from "react";

import { CountryDropdownButton } from "@similarweb/ui-components";

import type {
    ICountryDropdownItemProps,
    ICountryDropdownItemWrapperProps,
    ILocationObject,
} from "app/components/campaigns/queryBar-report/reports-pages-filters/CmapaignsIfraTypes";
import type { ICampaignsScrapingConfiguration } from "app/components/campaigns/shared/CampaignsConst";
import { getScarpingConfigsForCurrentDevice } from "app/components/campaigns/shared/CampaignsUtils";
import { commonWebSources } from "app/components/filters-bar/utils";
import { translate } from "app/filters/i18nFilter";

const MULTIPLE_LOCATIONS_ICON_ID = 999;

export const getCountryDropdownButtonTextAndIcon = (
    selectedCountries: ILocationObject[],
    device: string,
    scrapingConfigurations: ICampaignsScrapingConfiguration[],
): ICountryDropdownItemProps => {
    const totalAvailableLocationsAmount = getScarpingConfigsForCurrentDevice(scrapingConfigurations, device)?.length;
    const isAllSelected =
        (selectedCountries?.length === totalAvailableLocationsAmount && selectedCountries?.length > 1) ||
        selectedCountries?.length === 0;
    const selectedCountriesIcon: number =
        selectedCountries?.length !== 1 && totalAvailableLocationsAmount > 1
            ? MULTIPLE_LOCATIONS_ICON_ID
            : selectedCountries?.[0]?.countryIconID;
    const selectAllKeyText = getSelectAllDevicesText(device);
    const selectedCountriesText: string = isAllSelected
        ? translate(selectAllKeyText)
        : selectedCountries?.length > 1
          ? translate("seo.keywordsCampaigns.infra.locationsFilter.multiLocationsSelected", {
                amount: selectedCountries?.length,
            })
          : selectedCountries?.[0]?.text;
    return {
        id: selectedCountriesIcon,
        text: selectedCountriesText,
        selectedLocations: selectedCountries,
    };
};

export const getSelectAllDevicesText = (device: string) => {
    const selectAllKeyText = commonWebSources.mobileWeb().id.includes(device)
        ? "seo.keywordsCampaigns.infra.locationsFilter.allMobileLocations"
        : "seo.keywordsCampaigns.infra.locationsFilter.allDesktopLocations";
    return selectAllKeyText;
};

export const CampaignSelectedCountryItem: FC<ICountryDropdownItemWrapperProps> = (props) => {
    const {
        selectedCountries,
        disabled,
        currentCampaignConfiguration,
        isForDashboard,
        pickerButtonWidth,
        pickerButtonHeight,
        device,
    } = props;

    const { id, text } = getCountryDropdownButtonTextAndIcon(
        selectedCountries,
        device,
        currentCampaignConfiguration?.scrapingConfigurations,
    );
    return (
        <CountryDropdownButton
            countryId={id}
            height={pickerButtonHeight}
            width={pickerButtonWidth}
            disabled={disabled}
            cssClass={
                isForDashboard
                    ? null
                    : "DropdownButton--filtersBarDropdownButton DropdownButton--filtersBarDropdownButton--country"
            }
        >
            {text}
        </CountryDropdownButton>
    );
};
